<template>
  <v-main class="page-ticket page-ticket-select">
    <v-overlay absolute :value="isLoading">
       <v-progress-circular
           indeterminate
           size="24"
       />
    </v-overlay>
    <AppBar>
      <template #start>
        <v-btn icon plain :ripple="false" @click="goPage()">
          <IconBack/>
        </v-btn>
      </template>
    </AppBar>

    <v-layout fill-height column>
      <v-container fluid flex-fill>

        <div class="ticket-title-block">
          <h3 class="tit" v-html="info.text"></h3>
        </div>

        <div class="ticket-desc-block">
          <v-btn block depressed :ripple="false"
                 class="btn-see-ticket"
                 @click="ticketInfo();">
            선택하기 전 티켓에 대해 알아보아요!
            <v-spacer/>
            <i class="ez-dms-arr-right-md"></i>
          </v-btn>
          <ul class="list dot dot-sm mt-4" v-if="!hasTrial">
            <li>서비스 시작은 가이드캐릭터 및 찐한대화 일정선택 완료 후 진행됩니다.</li>
          </ul>
        </div>

        <!-- 직접 티켓 등록하기 -->
        <div class="ticket-register-block" v-if="!isSamsungFire && canRegisterDirectTicket">
          직접 티켓 등록하기&nbsp;&nbsp;&nbsp;
          <v-btn fab depressed color="primary"
                 class="btn-ticket-register"
                 @click="movePage('/fo/TicketRegister');">
            <i class="ez-dms-add"></i>
          </v-btn>
        </div>

        <!-- 보유중 티켓이 없을경우 -->
        <article v-if="ticketList.length === 0 && (goodsList.length === 0 || memberGb === '01')"
                 class="ticket-list no-data">
          <div v-if="memberGb === '01'" class="no-data-text">
            보유중인 티켓이 없습니다.
          </div>
          <div v-else class="no-data-text">
            판매중인 상품이 없습니다.
          </div>
        </article>
        <!-- 티켓 리스트 -->
        <article class="ticket-list">
          <!-- 선택/대기 -->
          <template v-if="ticketList.length > 0 && !payGo">
            <div v-for="n in ticketList.length" :key="n"
                class="ticket-list-item check-sign"
                :class="{ 'ticket-list-item--active' : current === n }"
            >
              <div class="ticket">
                <div class="ticket-info">
                  <div class="name">{{ ticketList[n - 1].ticketName }}</div>
                  <div class="desc">
                    {{ ticketList[n - 1].dscrt }}
                  </div>
                </div>
                <div class="ticket-state">
                  <v-btn text :ripple="false"
                        class="btn-ticket-state check-sign"
                        :class="{ 'btn-ticket-state--active' : current === n }"
                        @click="ticketSelect(n, 'ticketList');"
                  >
                    <span class="keep">보유</span>
                    <span class="chk" v-if="ticketList[n - 1].ticketState === '03'">
                      {{ ticketList[n - 1].ticketState === '03' ? '선택' : '대기' }}
                    </span>
                  </v-btn>
                </div>
              </div>
            </div>
          </template>
          <!-- 보유중 티켓이 없을경우 상품리스트 -->
          <template v-if="(ticketList.length === 0 || payGo) && memberGb === '02'">
            <div v-for="n in goodsList.length" :key="n"
                 class="ticket-list-item"
                 :class="{ 'ticket-list-item--active' : current === n }"
            >
              <div class="ticket">
                <div class="ticket-info">
                  <div class="name">{{ goodsList[n - 1].goodsNm }}</div>
                  <div class="desc">
                    {{ goodsList[n - 1].goodsDscrt }}
                  </div>
                </div>
                <div class="ticket-state">
                  <v-btn text :ripple="false"
                         class="btn-ticket-state check-sign"
                         :class="{ 'btn-ticket-state--active' : current === n }"
                         @click="ticketSelect(n, 'goodsList');"
                  >
                    <span class="chk">선택</span>
                    <span class="price">{{ goodsList[n - 1].saleAmt - goodsList[n - 1].dcAmt | comma }} 원</span>
                  </v-btn>
                </div>
              </div>
            </div>
          </template>
        </article>
      </v-container>
    </v-layout>

    <v-footer v-if="ticketList.length !== 0"
              app fixed grow color="white" class="content-footer"
    >
      <div class="footer-btns">
        <BlackBtn x-large str="시작하기" :disabled="btnDisable || isLoading" @click="ticketStart();"></BlackBtn>
        <v-btn color="primary" class="btn-plain"
               x-large depressed
               @click="$root.movePage('/')" v-if="isSamsungFire">
          일반관리 먼저 할게요.
        </v-btn>
      </div>
    </v-footer>
<!--    <v-footer v-if="ticketList.length === 0 && memberGb === '02'"-->
    <v-footer v-if="(ticketList.length === 0 || payGo) && memberGb === '02'"
              app fixed grow color="white" class="content-footer"
    >
      <div class="footer-btns">
        <BlackBtn x-large str="구매하기" :disabled="btnDisable" @click="orderStart();"></BlackBtn>
        <v-btn color="primary" class="btn-plain"
               x-large depressed
               @click="$root.movePage('/')" v-if="isSamsungFire">
          일반관리 먼저 할게요.
        </v-btn>
      </div>
    </v-footer>
  </v-main>
</template>

<script>
import store from '@/store'
import {mixinAuth, mixinTicket, mixinTrial} from '@/mixins'
import IconBack from "@/components/icons/Back"
import BlackBtn from "@/components/btns/BlackBtn"

export default {
  components: {
    IconBack,
    BlackBtn,
  },
  mixins: [mixinAuth, mixinTicket, mixinTrial],
  data: () => ({
    isSelect: false,
    btnDisable: true,
    ticketList: [],
    current: 0,
    usePsbYn: '',
    state: '',
    remainCnt: 0,
    goodsList: [],
    first: '',
    payGo: false,
    isLoading: false
  }),
  computed: {
    memberGb() {
      return store.state.auth.authUser.memberGb
    },
    canRegisterDirectTicket () {
      if (this.hasTrial) return false
      // 무명부 고객사만. 추후 변경예정
      return store.state.client.contract.rgstYn === "02"
    },
    info() {
      if (this.isSamsungFire) {
        return {
          text: `<span class="primary--text">맞춤형 집중관리 티켓</span>이<br /> 추천되었어요!`,
          visible: true
        }
      // } else if (this.ticketList.length === 0 && this.memberGb === '02') {
      } else if ((this.ticketList.length === 0 || this.payGo) && this.memberGb === '02') {
        return {
          text: `후유티켓을 구매하고<br /><b>여행을 시작해보세요.</b>`,
          visible: true
        }
      } else {
        return {
          text: `후유티켓을 선택하고<br /><b>여행을 시작해보세요.</b>`,
          visible: false
        }
      }
    }
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },
  created() {
    //안내문구
    // this.infoTextSet()
    this.first = this.$route.query.first;
    this.payGo = this.$route.query.payGo
  },
  mounted() {
    // 티켓 선택 후 가이드 및 찐한대화 일정 미입력 여부
    this.getUseOrdDtlNoGuide()
    //유저 티켓 리스트 API
    this.getTicketList()
    //유저 상품 리스트 API
    this.getGoodsList()
  },
  methods: {
    ticketSelect(n, list) {
      if (list === 'goodsList' || (list === 'ticketList' && this.ticketList[n-1].ticketState === '03') || !this.isLoading) {
        this.current = n
        this.btnDisable = false
      }
    },
    ticketStart() {
      const selected = this.ticketList[this.current - 1];
      let confirmMessage = "여행을 시작하시겠어요?"
      if (selected.allowsRealtalkService) confirmMessage += "<br>찐한 대화 일정 선택까지 완료하셔야 <br>여행이 시작됩니다.";

      this.$confirm(confirmMessage, {
        persistent: false,
        showClose: true,
        actions: {
          false: {text: '아니오'},
          true: {text: '예'}
        }
      }).then(result => {
        if (result) {
          //티켓 사용
          this.insertUserSolution(selected) // 솔루션 매핑 후 -> 티켓 사용처리 로직 수정
        }
      })

      //TODO EZN 개발진행 시 재결제 변경,유지 모달창 추가예정
      //this.movePage('/user/fo/guideSelect?m=1');
    },
    orderStart() {
      let goodsNo = this.goodsList[this.current - 1].goodsNo;
      this.$router.push(`/fo/purchase?goodsNo=${goodsNo}`)
    },
    async getGoodsList() {  // 유저 상품 리스트 API
      await store.dispatch('getGoodsList')
        .then(res => {
          if (res.success) {
            this.goodsList = res.data
          } else {
            console.log(res.msg)
          }
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
        })
    },
    async insertUserSolution (ticketList) {
        this.isLoading = true
        await store.dispatch('insertUserSolution', this.$_payload('ticketUserPo', ticketList))
            .then(async res => {
              if (res.success) {
                const { allowsRealtalkService, goodsNo }  = res.data;
                store.commit('setContract', {
                  ...store.state.client.contract,
                  allowsRealtalkService,
                  goodsNo
                })
                const url = store.state.client.contract.allowsRealtalkService ? '/fo/guideSelect?m=1' :'/fo/intro';
                this.movePage(url);
              } else {
                this.$alert(res.msg).then(result => {if (result) this.movePage('/');})
              }
            })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async getUseOrdDtlNoGuide() {  // 티켓 선택 후 가이드 및 찐한대화 일정 미입력 여부
      await store.dispatch('getUseOrdDtlNoGuide')
        .then(res => {
          if (res.success) {
            if (res.data != null) {
              this.movePage('/fo/guideSelect');
            }
          } else {
            console.log(res.msg)
          }
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
        })
    },
    ticketInfo() {
      this.movePage('/fo/ticketInfo');
    },
    goPage(){
      if (!this.isLoading) {
        if(this.first == 'first'){
          this.movePage('/')
        } else {
          this.prevPage()
        }
      }
    }
  }
}
</script>
